import { useState } from 'preact/hooks';
import { Route } from 'lucide-preact';
import { getAuthoredDescriptor } from '../builder-v2/index.ts';
import { TRACK_PIECE_THUMBNAIL_BY_DESCRIPTOR } from '../assets/track-piece-thumbnail-manifest.generated.ts';

interface AuthoredPieceThumbnailProps {
  readonly descriptorId: string;
  readonly priority?: boolean;
}

export function AuthoredPieceThumbnail({
  descriptorId,
  priority = false,
}: AuthoredPieceThumbnailProps) {
  const [failed, setFailed] = useState(false);
  const descriptor = getAuthoredDescriptor(descriptorId);
  const entry = TRACK_PIECE_THUMBNAIL_BY_DESCRIPTOR.get(descriptorId);
  const label = descriptor?.label ?? descriptorId;
  if (!entry || failed) {
    return (
      <span
        class="bc-authored-piece-thumbnail bc-authored-piece-thumbnail-fallback"
        role="img"
        aria-label={`${label} track preview unavailable`}
      >
        <Route aria-hidden="true" size={28} strokeWidth={1.8} />
        <span>{label}</span>
      </span>
    );
  }
  return (
    <img
      class="bc-authored-piece-thumbnail"
      src={`${import.meta.env.BASE_URL}${entry.url}`}
      width={entry.width}
      height={entry.height}
      loading={priority ? 'eager' : 'lazy'}
      decoding={priority ? 'sync' : 'async'}
      alt={`${label} track preview`}
      data-thumbnail-descriptor={descriptorId}
      data-thumbnail-view={entry.viewId}
      onError={() => setFailed(true)}
    />
  );
}
